import { render, staticRenderFns } from "./UserCompetenciesModal.vue?vue&type=template&id=621c7ea0&scoped=true"
import script from "./UserCompetenciesModal.vue?vue&type=script&lang=js"
export * from "./UserCompetenciesModal.vue?vue&type=script&lang=js"
import style0 from "./UserCompetenciesModal.vue?vue&type=style&index=0&id=621c7ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c7ea0",
  null
  
)

export default component.exports